import { useState, useEffect } from 'react';
import { apiFetch } from '../bizsuite-app';

/** Canonical list of consulting roles. Backed by
 *  Administration → Metadata → Lookups → Role (metadata_lookups category='role').
 *  Falls back to this built-in list if the API is unreachable or the category
 *  is empty — matches the old hardcoded values in CostSheet.
 */
export const ROLE_FALLBACK = [
  'Project Manager', 'Solution Architect', 'Technical Lead', 'Senior Consultant',
  'Consultant', 'Associate Consultant', 'Developer', 'Tester/QA', 'Basis Admin',
  'Functional Analyst', 'Business Analyst', 'Data Analyst', 'Other',
];

/** React hook: returns a stable, Active-only list of role names from the
 *  roles lookup table. Re-fetches once on mount. */
export function useRoleOptions() {
  const [roles, setRoles] = useState(ROLE_FALLBACK);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const r = await apiFetch('/api/metadata/lookups?category=role');
        if (!cancelled && r.ok) {
          const d = await r.json();
          const names = (d.rows || [])
            .filter(x => !x.status || x.status === 'Active')
            .sort((a, b) => (a.sort_order || 0) - (b.sort_order || 0))
            .map(x => x.name);
          if (names.length) setRoles(names);
        }
      } catch (_) { /* keep fallback */ }
      if (!cancelled) setLoading(false);
    })();
    return () => { cancelled = true; };
  }, []);
  return { roles, loading };
}
